module.exports = __webpack_public_path__ + "static/media/mineral.69266ffc.png";